export default __webpack_public_path__ + "static/media/line11.34deda20.svg";